import {memo} from 'react';

import styled from 'styled-components';

import Button from '~/shared/components/Button';
import TargetIcon from '~/assets/images/icons/targetIcon.svg?react';

const StyledButton = styled(Button)`
  position: absolute;
  z-index: 1;
  bottom: 16px;
  right: 16px;
  background-color: ${({theme}) => theme.colors.surface};
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 28px;
  box-shadow:
    0 2px 6px 0 rgba(0, 0, 0, 0.04),
    0 8px 12px -2px rgba(0, 0, 0, 0.06),
    0 4px 6px 0 rgba(0, 0, 0, 0.04);
`;

const RecenterButton = ({onRecenter}: {
  onRecenter: () => void;
}) => {
  return (
    <StyledButton onClick={onRecenter}>
      <TargetIcon className="avoid-fill-stroke" />
    </StyledButton>
  );
};

export default memo(RecenterButton);
